export default __webpack_public_path__ + "static/media/webcam15.58afd32d.jfif";